import React from 'react'
import { Loader } from 'semantic-ui-react'
import { compact, map } from 'lodash'

import styled from "styled-components";

const Container = styled.div`
  font-size: 14px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 16px;
`;

const Contact = styled.div`
  color: #868686;
`;

const Address = styled.div`
  margin-top: 24px;
`;

const Name = styled.div`
  color: #222222;
`;


export default class ContactSummary extends React.PureComponent {
  render() {
    const { contact } = this.props;

    if(contact) {
      const name = compact([contact.first_name, contact.last_name]).join(' ');
      const contactInfo = compact([contact.email, contact.phone, contact.company_billing ? contact.company : null]);
      let addressInfo;

      if(contact.address) {
        const { address } = contact;
        addressInfo = compact([address.address, address.address_line_2, compact([address.city, address.state]).join(' '), compact([address.postal_code, address.country && address.country.name]).join(' ')])
      }
      return (
        <Container>
          <Contact>
            <Name>{ name }</Name>
            { map(contactInfo, (line, i) => {
              return (
                <div key={`${line}-${i}`}>{ line }</div>
              )
            })}
          </Contact>
          { addressInfo && addressInfo.length > 0 ?
            <Address>
              { map(addressInfo, (line, i) => {
                return (
                  <div key={`${line}-${i}`}>{ line }</div>
                )
              })}
            </Address>
            : null
          }
        </Container>
      );
    }

    return <Loader active inline='centered' />;
  }
}